import type { CatalogOf } from '../types';
import type { en } from './en';

export const zh: CatalogOf<typeof en> = {
  header: {
    brand: 'Doc Assist',
  },
  language: {
    label: '语言',
  },
  consult: {
    booked: 'Anzu 将用{language}与您交谈。',
  },
  languages: {
    en: '英语',
    id: '印尼语',
    hi: '印地语',
    zh: '中文',
  },
  form: {
    title: '患者信息',
    sessionActive: '会话进行中',
    name: {
      label: '称呼',
      placeholder: '请输入患者全名',
      required: '请填写称呼',
    },
    dateOfBirth: {
      label: '出生日期',
      placeholder: '请选择出生日期',
      required: '请填写出生日期',
      invalid: '请输入有效的出生日期',
    },
    gender: {
      label: '出生时性别',
      placeholder: '请选择出生时性别',
      male: '男',
      female: '女',
      required: '请选择出生时性别',
    },
    mode: {
      label: '我偏好的沟通方式是',
      voice: '语音',
      text: '文字',
      required: '请选择沟通方式',
    },
    start: '开始新会话',
  },
  conversation: {
    emptyVoice: '您的对话将显示在这里',
    emptyText: 'Anzu 正在准备中，您可以在下方开始输入。',
    typing: 'Anzu 正在输入',
    you: '您',
    anzu: 'Anzu',
    placeholder: '输入您的消息...',
    send: '发送',
  },
  session: {
    end: '结束会话',
    saving: '正在保存会话...',
    confirmBody: '确定要结束本次会话吗？此操作无法撤销。',
    continue: '继续会话',
  },
  timeout: {
    title: '会话超时提醒',
    inactive: '您的会话已闲置 60 秒。',
    countdown: '您的会话将在 {seconds} 秒后自动结束。',
    hint: '点击"继续会话"以继续，或让会话自动结束。',
    endNow: '立即结束',
  },
  errors: {
    micPermission: 'Anzu 需要使用您的麦克风才能进行语音对话。请在浏览器中允许麦克风权限并重新打开链接，或重新开始并选择文字模式。',
  },
  disclaimer: {
    title: 'AIGP Health 平台一般免责声明',
    important: '重要提示：使用 AIGP HEALTH 平台前，请仔细阅读本免责声明。',
    lead: '使用 AIGP Health 的 AI 平台"Anzu"即表示用户确认并同意以下内容：',
    point1: '本平台使用人工智能（AI）收集您的信息。',
    point2: '输入 AI 系统的信息将在您预约的就诊时间转交给为您诊治的临床医生。',
    point3: '在您就诊之前，任何医生都不会查阅、审核或据此采取行动。',
    point4: '本平台不适用于医疗紧急情况。',
    point5: '如果您出现胸痛、呼吸困难、严重出血或任何其他严重或危及生命的状况，请立即结束本次会话并拨打 000。',
    point6: '如果完成本次诊前会话后您的状况恶化，您同意寻求紧急医疗救护或联系当地医院。',
    point7: '继续使用本平台即表示您确认这不是医疗紧急情况，并且您理解 Anzu 仅为诊前工具。',
    point8: '对于在需要紧急救治的情况下因延误就医而产生的后果，AIGP Health 不承担任何责任。',
    cancel: '取消',
    agree: '我同意 - 开始会话',
  },
  farewell: {
    preparing: '正在生成您的摘要...',
    preparingHint: '只需稍等片刻。',
    thanks: '感谢您使用 AIGP Health Doc Assist',
    loggingOut: '正在退出...',
  },
};
